
import Vue from 'vue'
import { format } from 'date-fns'
export default Vue.extend({
  name: 'FDatePicker',
  data() {
    return {
      show: false
    }
  },
  props: {
    value: {
      type: String,
      required: false
    },
    label: {
      type: String,
      required: false,
      default: ''
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    rules: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  computed: {
    formattedDate(): string {
      if (!this.value) return ''
      if (this.value!.length === 0) return ''
      return format(new Date(this.value!), 'dd.MM.yyyy')
    },
    changingValue: {
      set(newVal: string) {
        this.$emit('input', newVal)
      },
      get(): string {
        return this.value ?? ''
      }
    }
  }
})
